import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Input,
  Table
} from "reactstrap";
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback
} from 'react'
import {
  closeCreateUserModal,
  exportData,
  getUsersList,
  openCreateUserModal
} from "../../store/users/actions";
import NoRecord from '../../CommonData/norecord/norecord';
import VWPagination from '../../components/vwPagination/vwPagination';
import Skeleton from '../../components/vwSkeleton/vwSkeleton';
import { getPager } from "../../helper/common";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { USER_EXPORT_HEADERS } from "../../store/users/actionTypes";
import {
  ORGANIZATION_ADMIN,
  PROFILE_ROLES_LIST,
  SUPER_ADMIN
} from "../../store/users/role.constants";
import {
  ENABLED_STATUS_LIST,
  STATUS_LIST
} from "../../store/device/actionTypes";
import { excelPrint } from "../../helper/export";
import Message from "../../CommonData/Data/Message";
import VWLoading from "../../components/vwLoading/vwLoading";
import debounce from "lodash/debounce";
import moment from "moment";
import "../FixedColumn.css";

const style = {
  table: {
    width: '100%',
    display: 'table',
    borderSpacing: 0,
    borderCollapse: 'separate',
  },
  th: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
  },
};

const UserList = (props) => {

  const { isGetUserPending, errorMessage, currentProfile } = props;
  const [pageSize, setPageSize] = useState(10);
  const [pager, setPager] = useState({ currentPage: 1 });
  const [filter, setFilter] = useState();
  const [roleFilter, setRoleFilter] = useState();
  const [filterDisplay, setFilterDisplay] = useState();

  ///-----------------------FILTER------------------------------------------------
  const buildQuerDisplayName = () => {
    const { displayName } = filter || {};
    let searchDisplayName = '';
    if (displayName) {
      searchDisplayName += `${displayName}`;
    }
    return searchDisplayName
  }

  const buildQueryRoleDisplayName = () => {
    const { roleDisplayName } = filter || {};
    let searchRoleDisplayName = '';
    if (roleDisplayName) {
      searchRoleDisplayName += `${roleDisplayName}`;
    }
    return searchRoleDisplayName
  }

  const buildQueryOrgName = () => {
    const { orgName } = filter || {};
    let searchOrgName = '';
    if (orgName) {
      searchOrgName += `${orgName}`;
    }
    return searchOrgName
  }

  const buildQueryEmail = () => {
    const { email } = filter || {};
    let searchEmail = '';
    if (email) {
      searchEmail += `${email.replace(/\+/g, "%2B")}`;
    }
    return searchEmail
  }

  const buildQueryMobileNumber = () => {
    const { mobileNumber } = filter || {};
    let searchMobileNumber = '';
    if (mobileNumber) {
      searchMobileNumber += `${mobileNumber}`;
    }
    return searchMobileNumber
  }

  const buildQueryCreatedBy = () => {
    const { createdBy } = filter || {};
    let searchCreatedBy = '';
    if (createdBy) {
      searchCreatedBy += `${createdBy}`;
    }
    return searchCreatedBy
  }

  const buildQueryCreatedByEmail = () => {
    const { createdByEmail } = filter || {};
    let searchCreatedByEmail = '';
    if (createdByEmail) {
      searchCreatedByEmail += `${createdByEmail.replace(/\+/g, "%2B")}`;
    }
    return searchCreatedByEmail
  }

  const buildQueryAvailableDevices = () => {
    const { availableDevices } = filter || {};
    let searchAvailableDevices = '';
    if (availableDevices) {
      searchAvailableDevices += `${availableDevices}`;
    }
    return searchAvailableDevices
  }

  const buildQueryIsActive = () => {
    const { isActive } = filter || {};
    let searchIsActive = '';
    if ((isActive !== null) && (isActive !== undefined)) {
      searchIsActive += `${isActive}`;
    }
    return searchIsActive
  }

  const buildQueryIsEnabled = () => {
    const { isEnabled } = filter || {};
    let searchIsEnabled = '';
    if ((isEnabled !== null) && (isEnabled !== undefined)) {
      searchIsEnabled += `${isEnabled}`;
    }
    return searchIsEnabled
  }
  const buildCreatedDateTime = () => {
    const { createdDateTime } = filter || {};
    let searchCreatedDateTime = '';
    if (createdDateTime) {
      searchCreatedDateTime += `${createdDateTime}`;
    }
    return searchCreatedDateTime
  }

  const setPage = (page = 1) => {
    props.getUsersList(page, pageSize, buildQuerDisplayName(), buildQueryRoleDisplayName(), buildQueryOrgName(), buildQueryEmail(),
      buildQueryMobileNumber(), buildQueryCreatedBy(), buildQueryCreatedByEmail(), buildQueryAvailableDevices(), buildQueryIsActive(),
      buildQueryIsEnabled(), buildCreatedDateTime(), sortDirection, sortOrder);

    setPager(prevPager => {
      const totalPages = Math.ceil(props.totalRecordsCount / pageSize);
      const visiblePages = 5;
      const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
      const newPages = [];
      for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
        newPages.push(i);
      }
      return {
        ...prevPager,
        currentPage: page,
        totalPages,
        pages: newPages,
      };
    });
  };


  useEffect(() => {
    const currentUpdatePager = getPager(props.totalRecordsCount, 1, pageSize);
    setPager(currentUpdatePager);
  }, [props.totalRecordsCount, pageSize]);

  // useEffect(() => {
  //   const currentPageNo = pager && pager.currentPage;
  //   setPage(currentPageNo);
  // }, []);

  useEffect(() => {
    setPage();
  }, [pageSize])

  useEffect(() => {
    if (filter) {
      handleSearchClick();
    }
  }, [filter])

  const handleSearchClick = () => {
    setPage();
  }

  const sendBackendRequest = useCallback((name, value) => {
    setFilter((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }, []);

  const debouncedSendRequest = useMemo(() => {
    return debounce(sendBackendRequest, 1000);
  }, [sendBackendRequest]);

  const searchInputValidation = (event) => {
    const input = event.target;
    const { value, name } = input;
    debouncedSendRequest(name, value)
    setFilterDisplay({
      ...filterDisplay,
      [name]: value
    });
  }

  const handleKeypress = (e) => {
    if (e.key === 'Enter') {
      handleSearchClick();
    }
  };

  ///-----------------------SORTING------------------------------------------------

  const [sortDirection, setSortDirection] = useState('asc');
  const [sortOrder, setSortOrder] = useState(null);

  const handleSort = (column) => {
    if (sortOrder === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder(column);
      setSortDirection('asc');
    }
  };
  useEffect(() => {
    if (sortOrder && sortDirection) {
      setPage();
    }
  }, [sortOrder, sortDirection])

  //-----------------------EXPORT------------------------------------------------

  const handleExportUsers = () => {
    const { exportData, currentRole } = props;
    exportData().then((responseData) => {
      let headers = USER_EXPORT_HEADERS;
      let exportedData = [];
      const headerSizes = [30, 50, 15, 20, 15, 20, 50, 20, 20, 20, 20, 20]
      responseData.forEach((element) => {
        exportedData.push({
          DisplayName: element.displayName || 'NA',
          Email: element.email || 'NA',
          role: element.roleDisplayName || 'NA',
          orgName: element.orgName || 'NA',
          mobileNumber: element.mobileNumber || 'NA',
          CreatedBy: element.createdBy || 'NA',
          CreatedByEmail: element.createdByEmail || 'NA',
          totalAssignedDevices: element.totalAssignedDevices || 0,
          availableDevices: element.availableDevices || 0,
          isActive: element.isActive ? "Active" : "Inactive",
          isEnabled: element.isEnabled ? "enabled" : "Disabled",
          createdDateTime: element.createdDateTime ? moment(element.createdDateTime).format("DD/MM/YYYY") : "NA",
        });
      });

      if (!isAdmin) {
        exportedData = exportedData.filter(function (v) {
          delete v.CreatedBy
          delete v.CreatedByEmail
          return true;
        });
        headers = headers.filter(
          (e) =>
            !(
              e === "MANAGED BY" ||
              e === "MANAGED BY EMAIL"
            )
        );
      }
      excelPrint(exportedData, "User-List", headers, headerSizes);
    });
  };

  const isAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
    (currentProfile.roles[0].roleKey === SUPER_ADMIN ||
      currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN);

  useEffect(() => {
    const currentProfileRoles = props.currentProfile.roles || [];
    const relevantUserRoles = currentProfileRoles.length > 0 ? PROFILE_ROLES_LIST.filter((role) =>
      role.roleLevel > currentProfileRoles[0].rank) : [];
    setRoleFilter(relevantUserRoles)
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Card>
          <CardTitle className="p-2 mb-0 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
            USERS
            <div className="content-heading">
              <div className="ml-auto">
                <Link
                  type="button"
                  className="mr-1 btn btn-primary btn-sm"
                  to="add"
                >
                  <em className="fas fa-plus me-2"></em>Create User
                </Link>&nbsp;
                <Button
                  type="button"
                  size='sm'
                  color='primary'
                  onClick={handleExportUsers}
                >
                  <em className="fas fa-download me-2"></em>
                  Export
                </Button>
              </div>
            </div>
          </CardTitle>
        </Card>
        <Card>
          {errorMessage && (
            <Message
              type="danger"
              defaultMessage={errorMessage}
              baseClassName="alert"
            />
          )}
          <CardBody className='p-4'>
            <div style={{ maxHeight: "500px", overflowX: "auto" }}>
              <Table className="table table-striped table-hover table-nowrap w-100" size='sm' style={style.table}>
                <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: "10" }}>
                  <tr>
                    <th style={{ minWidth: "150px", cursor: "pointer" }} onClick={() => handleSort('displayName')}>
                      USER
                      {sortOrder === 'displayName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ minWidth: "200px", cursor: "pointer" }} onClick={() => handleSort('roleDisplayName')}>
                      ROLE
                      {sortOrder === 'roleDisplayName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ minWidth: "150px", cursor: "pointer" }} onClick={() => handleSort('orgName')}>
                      ORGANIZATION
                      {sortOrder === 'orgName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ minWidth: "150px", cursor: "pointer" }} onClick={() => handleSort('mobileNumber')}>
                      MOBILE NUMBER
                      {sortOrder === 'mobileNumber' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ paddingRight: "50px", minWidth: "150px", cursor: "pointer" }} onClick={() => handleSort('createdBy')}>
                      MANAGED BY
                      {sortOrder === 'createdBy' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('availableDevices')}>
                      AVAILABLE DEVICES
                      {sortOrder === 'availableDevices' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ paddingRight: "80px", cursor: "pointer" }} onClick={() => handleSort('isActive')}>
                      ACCOUNT  STATUS
                      {sortOrder === 'isActive' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ paddingRight: "80px", cursor: "pointer" }} onClick={() => handleSort('isEnabled')}>
                      ACTIVATION STATUS
                      {sortOrder === 'isEnabled' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ paddingRight: "80px", cursor: "pointer" }} onClick={() => handleSort('createdDateTime')}>
                      CREATED ON
                      {sortOrder === 'createdDateTime' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th className="text-center sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: 20 }}>
                      VIEW
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <Input
                        type="text"
                        className="form-control"
                        size='sm'
                        placeholder="Search"
                        name="email"
                        data-type="input"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                        value={filterDisplay && filterDisplay.email}
                      />
                    </th>
                    <th>
                      <Input
                        className="form-control"
                        type='select'
                        size='sm'
                        name="roleDisplayName"
                        placeholder="Select"
                        onChange={searchInputValidation}
                        value={filterDisplay && filterDisplay.roleDisplayName}
                      >
                        <option value="" >Select</option>
                        {roleFilter && roleFilter.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Input>
                    </th>
                    <th>
                      <Input
                        type="text"
                        className="form-control"
                        size='sm'
                        placeholder="Search"
                        name="orgName"
                        data-type="input"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                        value={filterDisplay && filterDisplay.orgName}
                      />
                    </th>
                    <th>
                      <Input
                        type="text"
                        className="form-control"
                        size='sm'
                        placeholder="Search"
                        name="mobileNumber"
                        data-type="input"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                        value={filterDisplay && filterDisplay.mobileNumber}
                      />
                    </th>
                    <th>
                      <Input
                        type="text"
                        className="form-control"
                        size='sm'
                        placeholder="Search"
                        name="createdByEmail"
                        data-type="input"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                        value={filterDisplay && filterDisplay.createdByEmail}
                      />
                    </th>
                    <th>
                      <Input
                        type="number"
                        className="form-control"
                        size='sm'
                        placeholder="Search"
                        name="availableDevices"
                        data-type="input"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                        value={filterDisplay && filterDisplay.availableDevices}
                      />
                    </th>
                    <th>
                      <Input
                        className="form-control"
                        type='select'
                        name="isActive"
                        size='sm'
                        placeholder="Select"
                        onChange={searchInputValidation}
                        value={filterDisplay && filterDisplay.isActive}
                      >
                        <option value="" >Select</option>
                        {STATUS_LIST && STATUS_LIST.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Input>
                    </th>
                    <th>
                      <Input
                        className="form-control"
                        type='select'
                        size='sm'
                        name="isEnabled"
                        placeholder="Select"
                        onChange={searchInputValidation}
                        value={filterDisplay && filterDisplay.isEnabled}
                      >
                        <option value="" >Select</option>
                        {ENABLED_STATUS_LIST && ENABLED_STATUS_LIST.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Input>
                    </th>
                    <th>
                      <Input
                        className="form-control"
                        type='date'
                        size='sm'
                        name="createdDateTime"
                        placeholder="Select"
                        onChange={searchInputValidation}
                        value={filterDisplay && filterDisplay.createdDateTime}
                      />
                    </th>
                    <th className="sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: 20 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {(props.userList && props.userList.length > 0) && !isGetUserPending ?
                    props.userList && props.userList.map((data, index) =>
                      <tr key={index}>
                        <td>
                          {data.displayName || "NA"}<br />
                          <small>{data.email || "NA"}</small>
                        </td>
                        <td>{data.roleDisplayName || "NA"}</td>
                        <td>{data.orgName || "NA"}</td>
                        <td>{data.mobileNumber || "NA"}</td>
                        <td>
                          {data.createdBy || "NA"}<br />
                          <small>{data.createdByEmail || "NA"}</small>
                        </td>
                        <td align="center">{data.availableDevices}</td>
                        <td>
                          {data.isActive ? (
                            <Badge color="success">Active</Badge>
                          ) : (
                            <Badge color="danger">Inactive</Badge>
                          )}
                        </td>
                        <td>
                          {data.isEnabled ? (
                            <Badge color="success">Enabled</Badge>
                          ) : (
                            <Badge color="danger">Disabled</Badge>
                          )}
                        </td>
                        <td>{data.createdDateTime ? moment(data.createdDateTime).format("DD MMM YYYY") : "NA"}</td>
                        <td className="sticky-column bg-white">
                          <Link
                            type="button"
                            className="btn btn-sm btn-light"
                            to={`/userlist/details/${data.id}`}
                          >
                            <em className="far fa-share-square"></em>
                          </Link>
                        </td>
                      </tr>
                    ) : isGetUserPending ? (
                      <tr>
                        <td colSpan={11} align="center" className="p-4">
                          <Skeleton type="body" />
                          <VWLoading />
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan={12}>
                          <NoRecord />
                        </td>
                      </tr>
                    )}
                </tbody>
              </Table>
            </div>
          </CardBody>
          <CardFooter>
            {props.userList && props.userList.length > 0 ?
              <VWPagination
                pager={pager}
                setPage={setPage}
                totalRecords={props.totalRecordsCount}
                pageSize={pageSize}
                setPageSize={setPageSize}
              />
              : null
            }
          </CardFooter>
        </Card>
      </div >
    </React.Fragment >
  )
}

const mapStateToProps = (state) => ({
  isCreateUserModalOpen: state.users.isCreateUserModalOpen,
  userList: state.users.users,
  errorMessage: state.users.userListError,
  isGetUserPending: state.users.isGetUserPending,
  totalRecordsCount: state.users.totalRecords,
  currentProfile: state.login.currentProfile,
  loading: state.users.loading
});

const mapDispatchToProps = (dispatch) => ({
  openCreateUserModal: () => dispatch(openCreateUserModal()),
  closeCreateUserModal: () => dispatch(closeCreateUserModal()),
  getUsersList: (currentPage, pagesize, searchDisplayName, searchRoleDisplayName, searchOrgName, searchEmail, searchMobileNumber, searchCreatedBy, searchCreatedByEmail, searchAvailableDevices, searchIsActive, searchIsEnabled, searchCreatedDateTime, sortDirection, sortOrder) =>
    dispatch(getUsersList(currentPage, pagesize, searchDisplayName, searchRoleDisplayName, searchOrgName, searchEmail, searchMobileNumber, searchCreatedBy, searchCreatedByEmail, searchAvailableDevices, searchIsActive, searchIsEnabled, searchCreatedDateTime, sortDirection, sortOrder)),
  exportData: () => dispatch(exportData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserList);

